const isUserRowlandsInStore = (selectedPharmacy) => {
  return (
    selectedPharmacy &&
    selectedPharmacy.brand !== undefined &&
    selectedPharmacy.brand !== null &&
    selectedPharmacy.brand.toLowerCase() === 'rowlands' &&
    (selectedPharmacy.ods_code === undefined || selectedPharmacy.ods_code === null)
  );
};

const isFirstOrder = (orderHistory) => {
  return orderHistory?.orders.length === 0;
};

const isUserMarketingPatient = (selectedPharmacy) => {
  return !(
    selectedPharmacy &&
    ((selectedPharmacy.ods_code !== null && selectedPharmacy.ods_code !== undefined) ||
      (selectedPharmacy.brand !== null && selectedPharmacy.brand !== undefined))
  );
};

const wasLastOrderToDsp = (orderHistory) => {
  return (
    orderHistory?.orders[0]?.fulfillment?.pharmacy_ods_code !== undefined &&
    orderHistory?.orders[0]?.fulfillment?.pharmacy_ods_code !== null &&
    orderHistory?.orders[0]?.fulfillment?.pharmacy_ods_code.toLowerCase() === 'fgf90'
  );
};

const getBasketMedicationName = (basket, medication) => {
 return basket.map((item) => {
    return medication.filter(({course_id}) => course_id === item).map(x => x.name)[0] || "";
  });
};

const allMedicationBasketIsContraceptive = (basket) => {
  return basket.length > 0 && basket.every(medication => medication.is_contraceptive);
}

const getBasketMedication = (basket, medication) => {
  return medication && basket && medication.filter(({course_id}) => basket.includes(course_id)
  )
}


export { isUserRowlandsInStore, isFirstOrder, isUserMarketingPatient, wasLastOrderToDsp, getBasketMedicationName, allMedicationBasketIsContraceptive, getBasketMedication};
